import React, { useEffect, useState, useRef } from "react";
import { useHistory, withRouter, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { performLogin } from "../../redux/AuthAction.js";
import {
	WebUrl,
	ApiUrl,
	ApiKey,
	LanguageOption,
	SessionKey,
	Language,
	LanguageSelectStyle,
} from "../../util/Constant.js";
import { useTranslation } from "react-i18next";
import Input from "../custom/Input.js";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import ApiEngine from "../../util/ApiEngine.js";
import {
	createFormBody,
	createMultiPartFormBody,
	stringIsNullOrEmpty,
} from "../../util/Util.js";
import {
	setBusy,
	setIdle,
	showResponseMessage,
    setLoginModal
} from "../../redux/AppAction.js";
import { saveLanguageId } from "../../redux/LanguageAction.js";
import SecureLS from "secure-ls";
/// <summary>
/// Author: -
/// </summary>
const Login = (props) => {
	var { t, i18n } = useTranslation();
	var _dispatch = useDispatch();
	var { isLoggedIn } = useSelector((state) => state.authState);
	var userData = useSelector((state) => state.authState.userData);
    const loginModal = useSelector((state)=>state.appState.loginModal)
	var _history = useHistory();
	var ls = new SecureLS();
	const {
		register: loginRegister,
		handleSubmit: loginHandleSubmit,
		errors: loginErrors,
	} = useForm();
	const {
		register: forgotPasswordRegister,
		handleSubmit: forgotPasswordHandleSubmit,
		errors: forgotPasswordErrors,
		watch: forgotPasswordWatch,
		setValue: forgotPasswordSetValue,
		unregister: forgotPasswordUnregister,
	} = useForm();
	const {
		register: tacVerifyRegister,
		handleSubmit: tacVerifyHandleSubmit,
		errors: tacVerifyErrors,
		watch: tacVerifyWatch,
		setValue: tacVerifySetValue,
		unregister: tacVerifyUnregister,
	} = useForm();
	const {
		register: ResetPasswordRegister,
		handleSubmit: ResetPasswordHandleSubmit,
		errors: ResetPasswordErrors,
		watch: ResetPasswordWatch,
		setValue: ResetPasswordSetValue,
		unregister: ResetPasswordUnregister,
		watch,
	} = useForm();
	const { handleSubmit: PasswordUpdatedHandleSubmit } = useForm();
	const { handleSubmit: recaptchaSubmit } = useForm();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [formattedPhoneNumber, setFormattedPhoneNumber] = useState("");
	const [loginFailCount, setLoginFailCount] = useState(0);
	const [loginAttemptUsername, setLoginAttemptUsername] = useState("");
	const [activeLanguage, setActiveLanguage] = useState(
		localStorage.getItem(SessionKey._LANGUAGE) || "EN"
	);
	const recaptcharef = useRef();
	const [isForgetPassword, setIsForgetPassword] = useState(false);
	const [isLogin, setIsLogin] = useState(true);
	const [verifyPhoneTAC, setVerifyPhoneTAC] = useState(false);
	const [isPasswordUpdated, setIsPasswordUpdated] = useState(false);
	const verifyState = {
		button: "1",
	};
	const [isUpdatePassword, setIsUpdatePassword] = useState(false);
	const [phoneNumber, setPhoneNumber] = useState("");
	const [tempPhoneNum, setTempPhoneNum] = useState("");
	const [countdownTAC, setCountdownTAC] = useState(false);
	const [username, setUsername] = useState("");
	const _MIN_PASSWORD_LENGTH = 6;
	const [inputValue, setInputValue] = useState("");
	const TEST_SITE_KEY = "6LffRtsbAAAAAODSwUqbIwV2mKf5HFmro6_OD4Yy"; //6LffRtsbAAAAAODSwUqbIwV2mKf5HFmro6_OD4Yy - Key
	/*6LffRtsbAAAAAIURcVT3-1jHgY7WZ_Neg2Z5XbnS - Secret*/
    const _TAC_VALID_TIMER = 60000;
    const _SECONDS_IN_MS = 1000;
    const [TACcountdownPeriod, setTACCountdownPeriod] = useState(
        _TAC_VALID_TIMER / _SECONDS_IN_MS
    );
    const _TAC_TIMEOUT_IN_MINUTES = 1;
    const [TACtimer, setTACtimer] = useState(setTimeout(() => { }, 60000));
    const [countdownPeriod, setCountdownPeriod] = useState(0);
    const [TACsent, setTACsent] = useState(true);
    const [TACtimedOut, setTACtimedOut] = useState(true);
    const [canSendTAC, setCanSendTAC] = useState(true);

    const [attemp, setAttemp] = useState(1);
    const [emailExist, setEmailExist] = useState(false);
    const [timerPeriod, setTimerPeriod] = useState(null);
    const [tacCode, setTacCode] = useState(""); 

	/// <summary>
	/// Author: -
	/// </summary>
	useEffect(() => {
		if (isLoggedIn) {
			if (loginAttemptUsername == "nn02") {
				_history.push(WebUrl._URL_CAMO_HOMEPAGE);
			} else {
				if (!window.ReactNativeWebView) {
					_history.push(WebUrl._URL_DASHBOARD);
				}
			}
		} else {
			if (window.ReactNativeWebView) {
				window.ReactNativeWebView.postMessage(
					JSON.stringify({
						action: "logout",
					})
				);
			}
		}
		if (ls.get("gR97lPRIn797")["PYTLczcty9uH"]) {
			document.getElementById("loginUsername").value =
				ls.get("gR97lPRIn797")["Do3SwI4cuvqR"];
			document.getElementById("loginPassword").value =
				ls.get("gR97lPRIn797")["gR1IPGBN01dS"];
		}
	}, [isLoggedIn]);

	/// <summary>
	/// Author: -
	/// </summary>
	const submitLoginForm = async (data, e) => {
		_dispatch(setBusy());
		setLoginAttemptUsername(data.username);
		if (data.isKeepedPassword) {
			ls.set("gR97lPRIn797", {
				Do3SwI4cuvqR: data.username,
				gR1IPGBN01dS: data.password,
				PYTLczcty9uH: data.isKeepedPassword,
			});
		} else {
			ls.set("gR97lPRIn797", {
				Do3SwI4cuvqR: "fake",
				gR1IPGBN01dS: "null",
				PYTLczcty9uH: false,
			});
		}
		await _dispatch(
			performLogin(
				data.username,
				data.password,
				data.isKeepedLogin,
				activeLanguage
			)
		);

		let params = {
			username: data.username,
		};
        _dispatch(setLoginModal(false))
		_dispatch(setIdle());
	};

	/// <summary>
	/// Author: -
	/// </summary>
	async function submitForgotPasswordForm(data) {
		_dispatch(setBusy());

		let formData = {
			language: "en",
			username: data.username,
			type: verifyState.button,
			usage: "resetPassword",
		};
		let formBody = createMultiPartFormBody(formData);
		var responseJson = await ApiEngine.post(ApiUrl._API_GENERATE_OTP, formBody);

		if (responseJson[ApiKey._API_SUCCESS_KEY]) {
			setCountdownTAC(false);
			setUsername(data.username);
			setPhoneNumber(responseJson.data);
			setTempPhoneNum(
				responseJson.data.replace(
					responseJson.data.substr(3, responseJson.data.length - 7),
					responseJson.data
						.substr(1, responseJson.data.length - 4)
						.replace(/./g, "*")
				)
			);
			setIsModalVisible(true);
			setVerifyPhoneTAC(true);
			setIsForgetPassword(false);
			setCanSendTAC(false);
			clearTimeout(TACtimer);
			clearTimeout(timerPeriod);
			setTACCountdownPeriod(_TAC_VALID_TIMER / _SECONDS_IN_MS);
			setTACsent(true);
			setTACtimedOut(false);
			setCountdownPeriod(_TAC_VALID_TIMER / _SECONDS_IN_MS);

			// if return object is email then directly show CS (CN player)
			let regEmail =
				/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
			if (regEmail.test(responseJson.data)) {
				setAttemp(attemp + 1);
			}
			setTimeout(() => {
				setCanSendTAC(true);
				setCountdownTAC(true);
			}, _SECONDS_IN_MS * 60 * _TAC_TIMEOUT_IN_MINUTES);
		} else {
			_dispatch(
				showResponseMessage(false, responseJson[ApiKey._API_MESSAGE_KEY])
			);
		}
		_dispatch(setIdle());
	}

	async function submitVerifyTAC(data) {
		_dispatch(setBusy());
		if (verifyState.button == 1) {
			let formData = {
				taccode: data.taccode,
				username: username,
			};
			let formBody = createMultiPartFormBody(formData);
			let TACjson = await ApiEngine.post(
				ApiUrl._API_VERIFY_RESET_PASSWORD_SMS,
				formBody
			);
			if (TACjson[ApiKey._API_SUCCESS_KEY]) {
				setTacCode(data.taccode)
				setVerifyPhoneTAC(false);
				setIsUpdatePassword(true);
				//resetForm();
			} else {
				_dispatch(
					showResponseMessage(
						TACjson[ApiKey._API_SUCCESS_KEY],
						TACjson[ApiKey._API_MESSAGE_KEY]
					)
				);
			}
		} else if (verifyState.button == 2) {
			let formData = {
				language: "en",
				username: username,
				type: verifyState.button,
				usage: "resetPassword",
			};
			let formBody = createMultiPartFormBody(formData);
			//data["phoneNumber"] = formattedPhoneNumber;
			data["language"] = "en";
			var responseJson = await ApiEngine.post(
				ApiUrl._API_GENERATE_OTP,
				formBody
			);

			if (responseJson[ApiKey._API_SUCCESS_KEY]) {
				setCountdownTAC(false);
				setPhoneNumber(responseJson.data);
				setTempPhoneNum(
					responseJson.data.replace(
						responseJson.data.substr(3, responseJson.data.length - 7),
						responseJson.data
							.substr(1, responseJson.data.length - 4)
							.replace(/./g, "*")
					)
				);
				setVerifyPhoneTAC(true);
				setIsForgetPassword(false);
				setAttemp(attemp + 1);
				verifyState.button = verifyState.button + 1;
				setCanSendTAC(false);
				clearTimeout(TACtimer);
				setTACCountdownPeriod(_TAC_VALID_TIMER / _SECONDS_IN_MS);
				setTACsent(true);
				setTACtimedOut(false);
				setCountdownPeriod(0);
				setCountdownPeriod(_TAC_VALID_TIMER / _SECONDS_IN_MS);
				clearTimeout(TACtimer);

				setTimeout(() => {
					setCanSendTAC(true);
					setCountdownTAC(true);
				}, _SECONDS_IN_MS * 60 * _TAC_TIMEOUT_IN_MINUTES);

				//resetForm();
			} else {
				_dispatch(
					showResponseMessage(
						responseJson[ApiKey._API_SUCCESS_KEY],
						responseJson[ApiKey._API_MESSAGE_KEY]
					)
				);
			}
		}
		_dispatch(setIdle());
	}

	async function submitNewPassword(data) {
		_dispatch(setBusy());
		let formData = {
			newpassword: data.newPassword,
			confpassword: data.confPassword,
			username: username,
			tacCode: tacCode
		};
		let formBody = createMultiPartFormBody(formData);

		var responseJson = await ApiEngine.post(
			ApiUrl._API_MEMBER_RESET_PASSWORD_BEFORE_LOGIN,
			formBody
		);

		if (responseJson[ApiKey._API_SUCCESS_KEY]) {
			setIsUpdatePassword(false);
			setIsPasswordUpdated(true);
		} else {
			_dispatch(
				showResponseMessage(
					responseJson[ApiKey._API_SUCCESS_KEY],
					responseJson[ApiKey._API_MESSAGE_KEY]
				)
			);
		}
		_dispatch(setIdle());
	}

	async function submitPasswordUpdated(data) {
		setIsUpdatePassword(false);
		setIsPasswordUpdated(false);
		setIsModalVisible(false);
	}

	/// <summary>
	/// Author: -
	/// </summary>
	function resetForm() {
		forgotPasswordUnregister(["username", "phoneNumber"]);
		setFormattedPhoneNumber("");
		setIsModalVisible(false);
	}

	async function onChange(value) {
		let params = {
			username: loginAttemptUsername,
		};
		var loginJson = await ApiEngine.post(
			ApiUrl._API_MANAGE_MEMBER_LOGIN_FAIL_COUNT,
			createFormBody(params)
		);
		if (loginJson[ApiKey._API_SUCCESS_KEY]) {
			setLoginFailCount(0);
			_dispatch(
				showResponseMessage(
					loginJson[ApiKey._API_SUCCESS_KEY],
					loginJson[ApiKey._API_MESSAGE_KEY]
				)
			);
		}
	}

	const onRecaptchaSubmit = () => {
		const recaptchaValue = recaptcharef.current.getValue();
	};

	/// <summary>
	/// Author: Wong
	/// </summary>
	const onChangeLanguage = async (selectedLanguage) => {
		i18n.changeLanguage(selectedLanguage);
		setActiveLanguage(selectedLanguage);
		_dispatch(saveLanguageId(selectedLanguage, true));
	};

	const [channels, setChannels] = useState([]);
	const [selectedChannel, setSelectedChannel] = useState();
	const [toggleModal, setToggleModal] = useState();

	useEffect(() => {
		if (selectedChannel) {
			if (!stringIsNullOrEmpty(selectedChannel.attachment)) {
				setToggleModal(true);
			}
		}
	}, [selectedChannel]);

	useEffect(() => {
		fetch(ApiUrl._API_GET_COMMUNICATION_CHANNELS + "?all=true", {
			method: ApiKey._API_GET,
			headers: {
				"Content-Type": ApiKey._API_FORM_URLENCODED,
				"X-Requested-With": ApiKey._API_XML_HTTP_REQUEST_KEY,
			},
		})
			.then((response) => response.json())
			.then((responseJson) => {
				if (responseJson[ApiKey._API_SUCCESS_KEY]) {
					setChannelData(responseJson[ApiKey._API_DATA_KEY]);
				}
			});
	}, []);

	function setChannelData(data) {
		var channels = [];
		data.map((d, index) => {
			var channel = {
				name: d.channelName,
				description: d.channelDescription,
				actionUrl: d.cta,
				image: d.channelImage,
				attachment: d.attachment,
			};

			channels.push(channel);
		});
		setChannels(channels);
	}

	function handleClick(channel) {
		if (window.ReactNativeWebView) {
			window.ReactNativeWebView.postMessage(
				JSON.stringify({
					action: "chat",
					//url: `${channel.actionUrl}`,
					url:
						channel.actionUrl.match(/live-chat/i) != null
							? `${window.location.origin}${channel.actionUrl}`
							: `${channel.actionUrl}`,
				})
			);
		} else {
			if (!stringIsNullOrEmpty(channel.actionUrl)) {
				setToggleModal(false);
				window.location.href = channel.actionUrl;
			} else {
				setSelectedChannel(channel);
				setToggleModal(true);
			}
		}
	}

	const handleChange = (e) => {
		setInputValue(e.target.value.toLowerCase());
	};

	return (
        <div>
            {/* ////login modal */}
            <Modal
                id="login-register-modal"
                fade={false}
                contentClassName={"login-register-modal"}
                isOpen={loginModal}
                toggle={() => {
                    _dispatch(setLoginModal(false))
                }}
                // backdrop={'static'}
                centered
            >
                <ModalBody>
                    <div className="login-register-container">
                        <div className="login-register-header">
                            <div className="modal-logo">
                                <img
                                    src={
                                        require("../../assets/img/logobig2.png")
                                    }
                                    className="img-responsive"
                                    style={{ height: "40px" }}
                                    alt="logo"
                                    loading="lazy"
                                />
                            </div>
                            <div onClick={() => {_dispatch(setLoginModal(false))}}>
                                <svg
                                    className="cursor-pointer"
                                    viewBox="0 0 1024 1024"
                                    width="20px"
                                    height="20px"
                                    style={{ display: "inline-block", stroke: "currentColor", fill: "currentColor" }}
                                    >
                                    <path d="M512 439.603l-362.035-362.035-72.397 72.397 362.035 362.035-362.035 362.035 72.397 72.397 362.035-362.035 362.035 362.035 72.397-72.397-362.035-362.035 362.035-362.035-72.397-72.397-362.035 362.035z"></path>
                                </svg>
                            </div>
                        </div>
                        <div className="login-register-body">
                            <div className="left">
                                    <img
                                    src={
                                        require("../../assets/img/desktop/modal-image.png")
                                    }
                                    className="img-responsive"
                                    alt="okup"
                                    loading="lazy"
                                />
                            </div>
                            <div className="right">
                                <div className="w-100">
                                    {isLogin && (
                                        <form
                                            className="margin-bottom-0 custom-form text-left"
                                            onSubmit={loginHandleSubmit(submitLoginForm)}
                                        >
                                            <div className="input-container">
                                                <label className="text-capitalize">
                                                    {t("ENTER_USERNAME")}
                                                </label>
                                                <Input
                                                    id="loginUsername"
                                                    className="white-input"
                                                    name="username"
                                                    ref={loginRegister({ required: true })}
                                                    autoFocus
                                                    errors={loginErrors}
                                                    placeholder={t("ENTER_USERNAME")}
                                                    value={inputValue}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="input-container">
                                                <label className="text-capitalize">
                                                    {t("ENTER_PASSWORD")}
                                                </label>
                                                <Input
                                                    id="loginPassword"
                                                    className="white-input"
                                                    containerClassName=" form-password-group"
                                                    name="password"
                                                    ref={loginRegister({ required: true })}
                                                    type="password"
                                                    errors={loginErrors}
                                                    placeholder={t("ENTER_PASSWORD")}
                                                />
                                            </div>
                                            <label
                                                className="custom-checkbox mt-4 text-capitalize"
                                                style={{ cursor: "pointer" }}
                                            >
                                                <input type="checkbox" className="form-checkbox-label" />
                                                <span className="checkmark"></span>
                                                {t("KEEP_LOGGED_IN")}
                                            </label>
                                            <div>
                                                <button className="btn btn-custom font20 mt-4 text-capitalize">
                                                    {t("LOGIN")}
                                                </button>
                                            </div>
                                            <div className="text-center mt-3">
                                                <div 
                                                    onClick={() => {
                                                        setIsForgetPassword(true);
                                                        setIsLogin(false);
                                                    }}
                                                >
                                                    <button
                                                        type="button"
                                                        className="btn btn-link p-0 forgot-btn text-lblue1 text-underline text-capitalize"
                                                    >
                                                        {t("FORGOT_PASSWORD")} ?
                                                    </button>
                                                </div>
                                            </div>

                                            {channels.map((channel, index) => {
                                                if (channel.name == "Telegram") {
                                                    return (
                                                        <div
                                                            key={index}
                                                            className="live-chat-box"
                                                            onClick={() => {
                                                                if (!stringIsNullOrEmpty(channel.actionUrl)) {
                                                                    handleClick(channel);
                                                                } else if (channel.name == "Livechat") {
                                                                }
                                                            }}
                                                            style={{
                                                                borderBottom: "unset",
                                                                justifyContent: "center",
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            <div
                                                                className="first"
                                                                style={{
                                                                    border: "1px solid",
                                                                    padding: "10px",
                                                                    borderRadius: "10px",
                                                                }}
                                                            >
                                                                <div>
                                                                    <img
                                                                        src={channel.image}
                                                                        className="img-responsive border-radius-100"
                                                                        alt="icon"
                                                                        style={{ width: "25px", height: "25px" }}
                                                                        loading="lazy"
                                                                    />
                                                                </div>
                                                                <div>
                                                                    <h6
                                                                        className="mb-0"
                                                                        style={{ color: "unset", fontWeight: "normal" }}
                                                                    >
                                                                        {t("CUSTOMER_SERVICE")}
                                                                    </h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                            })}
                                        </form>
                                    )}
                                    {isForgetPassword && (
                                        <>
                                            <form
                                                className="margin-bottom-0 custom-form text-left"
                                                onSubmit={forgotPasswordHandleSubmit(submitForgotPasswordForm)}
                                            >
                                                <label className="text-capitalize">
                                                    {t("ENTER_USERNAME")}
                                                </label>
                                                <Input
                                                    type="text"
                                                    name="username"
                                                    id="username"
                                                    className="white-input"
                                                    placeholder={t("USERNAME")}
                                                    autoComplete={"off"}
                                                    ref={forgotPasswordRegister({ required: "REQUIRED_USERNAME" })}
                                                    errors={forgotPasswordErrors}
                                                />

                                                <div>
                                                    <button className="btn btn-custom font20 mt-4 text-capitalize">
                                                        {t("RESET_PASSWORD")}
                                                    </button>
                                                </div>

                                                {channels.map((channel, index) => {
                                                    if (channel.name == "Telegram") {
                                                        return (
                                                            <div
                                                                key={index}
                                                                className="live-chat-box"
                                                                onClick={() => {
                                                                    if (!stringIsNullOrEmpty(channel.actionUrl)) {
                                                                        handleClick(channel);
                                                                    } else if (channel.name == "Livechat") {
                                                                    }
                                                                }}
                                                                style={{
                                                                    borderBottom: "unset",
                                                                    justifyContent: "center",
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                <div
                                                                    className="first"
                                                                    style={{
                                                                        border: "1px solid",
                                                                        padding: "10px",
                                                                        borderRadius: "10px",
                                                                    }}
                                                                >
                                                                    <div>
                                                                        <img
                                                                            src={channel.image}
                                                                            className="img-responsive border-radius-100"
                                                                            alt="icon"
                                                                            style={{ width: "25px", height: "25px" }}
                                                                            loading="lazy"
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        <h6
                                                                            className="mb-0"
                                                                            style={{ color: "unset", fontWeight: "normal" }}
                                                                        >
                                                                            {t("CUSTOMER_SERVICE")}
                                                                        </h6>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    }
                                                })}
                                            </form>
                                        </>
                                    )}
                                    {verifyPhoneTAC && (
                                        <form onSubmit={tacVerifyHandleSubmit(submitVerifyTAC)}>
                                            <div className="margin-bottom-0 custom-form text-left">
                                                <label className="text-capitalize">
                                                    {t("ENTER_VERIFICATION_CODE")}
                                                </label>
                                                <Input
                                                    type="text"
                                                    id="taccode"
                                                    name="taccode"
                                                    ref={tacVerifyRegister()}
                                                    className="white-input"
                                                    placeholder={t("TAC_CODE")}
                                                    autoComplete="off"
                                                />
                                                <span className="font12 text-capitalize">
                                                    {t("PHONE_TAC_SEND_TO")}
                                                    {tempPhoneNum}
                                                </span>
                                                {TACsent && countdownPeriod != 0 && (
                                                    <p className="tac-countdown mt-2 font12 text-capitalize">
                                                        {t("TAC_SENT")} {t("RESEND_IN")} {countdownPeriod}s
                                                    </p>
                                                )}
                                                <div>
                                                    <button
                                                        className="btn btn-custom font20 mt-4 text-capitalize"
                                                        type="submit"
                                                        onClick={() => (verifyState.button = "1")}
                                                    >
                                                        {t("CONTINUE")}
                                                    </button>
                                                </div>
                                            </div>
                
                                            {countdownTAC && countdownPeriod == 0 && (
                                                <div>
                                                    <button
                                                        className="f-weight-500 mt-3 font12 text-redlight text-capitalize"
                                                        style={{
                                                            background: "none",
                                                            border: "none",
                                                            padding: 0,
                                                            font: "inherit",
                                                            cursor: "pointer",
                                                            outline: "inherit",
                                                        }}
                                                    >
                                                        {t("DIDNT_RECEIVE_A_CODE_TRY_OTHER_METHOD")}
                                                    </button>
                
                                                    {attemp == 1 && emailExist && (
                                                        <div>
                                                            <button
                                                                className="btn btn-custom font20 mt-4 text-capitalize"
                                                                type="submit"
                                                                onClick={() => (verifyState.button = 2)}
                                                            >
                                                                {t("RECEIVE_OTP_VIA_EMAIL")}
                                                            </button>
                                                            {/*<button className="btn btn-custom font20 mt-4" onClick={() => sendTACCode(OTP_VIA_WHATSAPP)}>*/}
                                                            {/*	{t("RECEIVE_OTP_VIA_WHATSAPP")}*/}
                                                            {/*</button>*/}
                                                        </div>
                                                    )}
                                                    {attemp == 2 || (!emailExist) ? (
                                                        <div>
                                                            <button
                                                                className="btn btn-custom font20 mt-4 text-capitalize"
                                                                type="button"
                                                                onClick={() => _history.push(WebUrl._URL_LIVECHAT)}
                                                            >
                                                                {t("CONTACT_CUSTOMER_SERVICE")}
                                                            </button>
                                                        </div>
                                                    ):""}
                                                </div>
                                            )}
                                        </form>
                                    )}
                                    {isUpdatePassword && (
                                        <form
                                            className="margin-bottom-0 custom-form text-left"
                                            onSubmit={ResetPasswordHandleSubmit(submitNewPassword)}
                                        >
                                            <label className="text-capitalize">
                                                {t("ENTER_NEW_PASSWORD")}
                                            </label>
                                            <Input
                                                type="password"
                                                name="newPassword"
                                                id="newPassword"
                                                containerClassName=" form-password-group"
                                                className="white-input"
                                                placeholder={t("NEW_PASSWORD")}
                                                autoComplete="off"
                                                ref={ResetPasswordRegister({
                                                    required: true,
                                                    minLength: {
                                                        value: _MIN_PASSWORD_LENGTH,
                                                        message: t("MIN_CHARACTERS", {
                                                            length: _MIN_PASSWORD_LENGTH,
                                                        }),
                                                    },
                                                    validate: (value) =>
                                                        watch("confPassword") == "" ||
                                                        value == watch("confPassword") ||
                                                        "PASSWORD_MISMATCH",
                                                })}
                                                errors={ResetPasswordErrors}
                                            />
                                            <label className="text-capitalize">
                                                {t("ENTER_CONFIRM_PASSWORD")}
                                            </label>
                                            <Input
                                                type="password"
                                                name="confPassword"
                                                id="confPassword"
                                                containerClassName=" form-password-group"
                                                className="white-input"
                                                placeholder={t("CONFIRM_NEW_PASSWORD")}
                                                autoComplete="off"
                                                ref={ResetPasswordRegister({
                                                    required: true,
                                                    minLength: {
                                                        value: _MIN_PASSWORD_LENGTH,
                                                        message: t("MIN_CHARACTERS", {
                                                            length: _MIN_PASSWORD_LENGTH,
                                                        }),
                                                    },
                                                    validate: (value) =>
                                                        watch("newPassword") == "" ||
                                                        value == watch("newPassword") ||
                                                        "PASSWORD_MISMATCH",
                                                })}
                                                errors={ResetPasswordErrors}
                                            />
                                            <div>
                                                <button className="btn btn-custom font20 mt-4 text-capitalize">
                                                    {t("RESET_PASSWORD")}
                                                </button>
                                            </div>
                                        </form>
                                    )}
                                    {isPasswordUpdated && (
                                        <form onSubmit={PasswordUpdatedHandleSubmit(submitPasswordUpdated)}>
                                            <div>
                                                <div className="welcome justify-content-center" id="Success">
                                                    <div className="text-center">
                                                        <div className="">
                                                            <img
                                                                src={require("../../assets/img/new_icons/checked.png")}
                                                                className="img-responsive"
                                                                alt="icon"
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                        <h1 className="mt-3 text-capitalize">{t("SUCCESS")}!</h1>
                                                        <p className="font16 text-capitalize">
                                                            {t("RESET_PASSWORD_SUCCESS")}
                                                        </p>
                                                    </div>
                                                    <div className="width-100-p mt-3 text-capitalize">
                                                        <Link
                                                            key="0"
                                                            to={{
                                                                pathname: WebUrl._URL_LOGIN,
                                                            }}
                                                        >
                                                            <div className="btn btn-custom font20">
                                                                {t("CLOSE")}
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </div>
		
	);
};

export default withRouter(Login);
